/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  GamoraFoundationAdapterQuery,
  GamoraFoundationAdapterQueryArgs,
  GamoraFoundationAdapterQueryOperator,
} from '../query.js';

/**
 * @public
 */
export type GamoraFoundationAdapterQueryClearOperand = [string];

/**
 * @public
 */
export type GamoraFoundationAdapterQueryClearResult = boolean;

/**
 * @public
 */
export type GamoraFoundationAdapterQueryClearArgs =
  GamoraFoundationAdapterQueryArgs<GamoraFoundationAdapterQueryClearOperand>;

/**
 * @public
 */
export class GamoraFoundationAdapterQueryClear extends GamoraFoundationAdapterQuery<
  GamoraFoundationAdapterQueryClearOperand,
  GamoraFoundationAdapterQueryClearResult
> {
  protected override _operator: GamoraFoundationAdapterQueryOperator =
    GamoraFoundationAdapterQueryOperator.CLEAR;
  constructor(args: GamoraFoundationAdapterQueryClearArgs) {
    super(args);
  }

  /**
   * Constructs query
   * @param operand The operand
   */
  static override fromOperand(
    operand: GamoraFoundationAdapterQueryClearOperand,
    options?: any,
  ): GamoraFoundationAdapterQueryClear {
    return new GamoraFoundationAdapterQueryClear({
      operand,
      options,
    });
  }
}
